declare namespace $ {

	type $mol_check__checked_bog_blitz_radio_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['menu_showed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__sub_bog_blitz_radio_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_string_button__value_bog_blitz_radio_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['volume_input'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_button_minor__title_bog_blitz_radio_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_radio_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['volume_up'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_blitz_radio_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_radio_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['volume_down'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_blitz_radio_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_blitz_radio_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_radio_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['stop_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_blitz_radio_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['station_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_radio_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['station_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_blitz_radio_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_radio['menu_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_blitz_radio extends $mol_pop {
		menu_showed( next?: boolean ): boolean
		Icon( ): $mol_icon_music
		Toggle( ): $mol_check
		volume_input( next?: string ): string
		Volume_label( ): $mol_string_button
		volume_up( next?: any ): any
		Volume_up( ): $mol_button_minor
		volume_down( next?: any ): any
		Volume_down( ): $mol_button_minor
		Volume_row( ): $mol_view
		stop_click( next?: any ): any
		Stop_button( ): $mol_button_minor
		station_title( id: any): string
		station_click( id: any, next?: any ): any
		Station( id: any): $mol_button_minor
		menu_content( ): readonly(any)[]
		Menu( ): $mol_view
		showed( next?: ReturnType< $bog_blitz_radio['menu_showed'] > ): ReturnType< $bog_blitz_radio['menu_showed'] >
		Anchor( ): ReturnType< $bog_blitz_radio['Toggle'] >
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=radio.view.tree.d.ts.map